import { render, staticRenderFns } from "./ItemStatsDisplayArmor.vue?vue&type=template&id=dc01eab8"
import script from "./ItemStatsDisplayArmor.vue?vue&type=script&lang=js"
export * from "./ItemStatsDisplayArmor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports